import { inject, observer } from 'mobx-react';
import withRouter from '@/components/withRouter';
import styles from './styles/RoleIntroduce.module.scss';
import Arrow from './components/Arrow/Arrow';
import defaultAvatar from '@/assets/images/simulation/default_avatar.png';
import { Storage } from '@/utils/Storage';
import { useEffect } from 'react';
const RoleIntroduce = (props) => {
    let { navigate, params } = props;
    let { agentId, caseId, sceneId } = params;
    let { simulation } = props.store;
    let { character = { other_roles: [] }, goal, rules, setHeaderIcon, verifyLogin } = simulation;
    // 模拟数据 - 从设计图中提取

    const onclickArrow = async () => {
        let res = await verifyLogin();
        if (!res) {
            return;
        }
        navigate(`/web/o/${agentId}/simulation/${caseId}/${sceneId}/event`, { replace: true });
    };
    useEffect(() => {
        setHeaderIcon({
            role: false,
            back: true,
            reStart: false
        });
        let backGuide = Storage.get(simulation.backStorageName);
        if (!backGuide) {
            simulation.setGuideModal('back');
        }
    }, []);
    return (
        <div className={styles.container}>
            <div onClick={onclickArrow} className={styles.arrowContainer}>
                <Arrow></Arrow>
            </div>
            {/* 角色信息区域 */}
            <div className={styles.roleInfoSection}>
                <div className={styles.avatarContainer}>
                    <div className={styles.avatar}>
                        {/* 实际项目中替换为真实头像 */}
                        <img src={character.avatar || defaultAvatar} alt={character.name} />
                    </div>
                    <div className={styles.roleName}>
                        <span className={styles.roleLabel}>【你】：{character?.name}</span>
                        <span className={styles.roleText}>{character?.role}</span>
                    </div>
                </div>
            </div>

            {/* 角色卡片区域 */}
            <div className={styles.roleCardsSection}>
                <div className={styles.roleCardsContainer}>
                    {character?.other_roles &&
                        character?.other_roles.map((role, index) => (
                            <div key={index} className={styles.roleCard}>
                                <div className={styles.roleCardName}>{role.name}</div>
                                <div className={styles.roleCardDescription}>{role.intro}</div>
                            </div>
                        ))}
                </div>
            </div>

            <div className={styles.sectionWrap}>
                {/* 目标区域 */}
                <div className={styles.section}>
                    <div className={styles.sectionTitle}>【目标】</div>
                    <div className={styles.sectionContent}>{goal?.description}</div>
                </div>
                <div className={styles.splitLine}></div>
                {/* 行为约束规则区域 */}
                <div className={styles.section}>
                    <div className={styles.sectionTitle}>【行为约束规则】</div>
                    <ul className={styles.rulesList}>
                        {rules.map((rule, index) => (
                            <li key={index} className={styles.ruleItem}>
                                {rule}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default withRouter(inject('store')(observer(RoleIntroduce)));
